import MuiMenuItem, { MenuItemProps } from '@mui/material/MenuItem';

function MenuItem(props: MenuItemProps) {
  return <MuiMenuItem {...props} />;
}

export default MenuItem;
